import { SANITIZE_PROFILE_DEFAULT } from './profiles/default';
const getLocationHost = () => {
    try {
        // Window.parent can rarely be null e.g. for contentWindow of an iframe that is already removed from the parent.
        if (window.parent !== null) {
            // Access to the window parent is not always available due to cross-origin restrictions
            // Hence we need to wrap this in a try/catch
            // At time of writing the only known case where this might happen is when
            // iframing the app in Testbox (partner integration)
            return window.parent.location.host;
        }
    }
    catch (error) {
        console.warn('Error getting location host', error);
    }
    return null;
};
export const addTargetAndRelToLinks = (htmlString) => {
    if (!htmlString) {
        return htmlString;
    }
    const div = document.createElement('div');
    // TODO: [TEAMS-12075] Investigate improper use of innerHTML
    // eslint-disable-next-line no-unsanitized/property
    div.innerHTML = htmlString;
    div.querySelectorAll('a').forEach((a) => {
        var _a;
        const href = a.getAttribute('href');
        if (!href) {
            return;
        }
        const host = getLocationHost();
        const includesHost = host && href.includes(host);
        const includesProtocol = href.includes('://');
        const isFeatureUrl = !!href.match('^(callto:|tel:|mailto:)');
        const isAllowedScheme = (_a = SANITIZE_PROFILE_DEFAULT.allowedSchemes) === null || _a === void 0 ? void 0 : _a.some((scheme) => href.includes(`${scheme}:`));
        if (!isAllowedScheme && !includesProtocol && !isFeatureUrl) {
            a.setAttribute('href', `//${href}`);
        }
        if (!includesHost && !isFeatureUrl) {
            a.setAttribute('target', '_blank');
            a.setAttribute('rel', 'noopener noreferrer');
        }
    });
    return div.innerHTML;
};
export const channelToSanitizationProfile = {
    contactform: 'email',
    email: 'email',
    notes: 'email',
    bulk: 'email',
    widgetchat: 'widgetchat',
    messenger: 'dixaMessenger',
    facebookmessenger: 'messaging',
    whatsapp: 'messaging',
    sms: 'messaging',
    twitter: 'messaging',
};
export const getMessageSanitizationChannel = (message) => ['conversation:wrapup_message', 'conversation:wrapup_added'].includes(message.type)
    ? 'notes'
    : message.channel;
export function removePlaceholderParagraphs(html) {
    return html
        .replace(/<\/placeholderp>\n*<placeholderp/g, '</div><br /><div')
        .replace(/<placeholderp/g, '<div')
        .replace(/<\/placeholderp>/g, '</div>');
}
